import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApiClient from "../../../api/admin";

const useClearOrderMutation = (clockId: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["clearOrder", clockId],
    mutationFn: () => adminApiClient.clearOrder(clockId),
    onSettled: () =>
      queryClient.invalidateQueries({ queryKey: ["machine", clockId] }),
  });
};

export default useClearOrderMutation;
